import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=0a12ab2c&scoped=true"
import script from "./ImageSlider.vue?vue&type=script&lang=js"
export * from "./ImageSlider.vue?vue&type=script&lang=js"
import style0 from "./ImageSlider.vue?vue&type=style&index=0&id=0a12ab2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12ab2c",
  null
  
)

export default component.exports